import {
  INICIA_REMATRICULA,
  SALVA_REMATRICULA_SUCESSO,
  LIMPAR_REMATRICULA,
  LISTA_ESCOLAS_REMATRICULA_SUCESSO,
  LISTA_CURSOS_REMATRICULA_SUCESSO,
  LISTA_SERIES_REMATRICULA_SUCESSO,
  LISTA_TURMAS_ORIGEM_REMATRICULA_SUCESSO,
  LISTA_ANOS_DESTINO_REMATRICULA_SUCESSO,
  LISTA_TURMAS_DESTINO_REMATRICULA_SUCESSO,
  ON_SHOW_LOADER,
  ON_HIDE_LOADER,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  ON_SHOW_SUCCESS_MESSAGE,
  NOVA_REMATRICULA,
  CANCELA_EDICAO,
  VERIFICA_SEQUENCIA_ENTURMACAO_SUCESSO,
  LISTA_TURMAS_FILTRO_REMATRICULA_SUCESSO,
  LISTA_REMATRICULA_SUCESSO,
  DETALHE_REMATRICULA_SUCESSO,
  FECHAR_DETALHE_REMATRICULA,
  ALTERACAO_COMBO,
  ALTERACAO_CAMPO
} from "constants/ActionTypes";

const INIT_STATE = {
  loader: false,
  edicao: false,
  alertMessage: '',
  showMessageSuccess: false,
  showMessageError: false,

  colunasGrid: [
    { titulo: 'Escola', propriedadeApi: 'nomeEscola', alinhamento: 'left' },
    { titulo: 'Turma Origem', propriedadeApi: 'nomeTurmaOrigem', alinhamento: 'left' },
    { titulo: 'Turma Destino', propriedadeApi: 'nomeTurmaDestino', alinhamento: 'left' },
    { titulo: 'Total Alunos', propriedadeApi: 'totalAlunos', alinhamento: 'center' },
    { titulo: 'Processado em', propriedadeApi: 'dataProcessamento', alinhamento: 'center' }
  ],
  listGrid: [],
  listGridComFiltro: [],
  carregandoLista: false,

  // Filtros
  escolaFiltro: '',
  anoFiltro: '',
  turmaOrigemFiltro: '',
  turmaDestinoFiltro: '',

  escolas: [],
  cursos: [],
  series: [],
  turmasOrigem: [],
  anosDestino: [],
  turmasDestino: [],
  turmasFiltro: [],
  detalhe: null,
  exibirDetalhe: false
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case INICIA_REMATRICULA: {
      return {
        ...state,
        loader: false,
        escolas: [],
        cursos: [],
        series: [],
        turmasOrigem: [],
        anosDestino: [],
        turmasDestino: []
      };
    }

    case LIMPAR_REMATRICULA: {
      return {
        ...state,
        loader: false,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false
      };
    }

    case LISTA_ESCOLAS_REMATRICULA_SUCESSO: {
      return {
        ...state,
        loader: false,
        escolas: action.payload,
        // Limpa dependentes
        cursos: [],
        series: [],
        turmasOrigem: [],
        anosDestino: [],
        turmasDestino: [],
        turmasFiltro: []
      };
    }

    case LISTA_CURSOS_REMATRICULA_SUCESSO: {
      return {
        ...state,
        loader: false,
        cursos: action.payload,
        // Limpa dependentes
        series: [],
        turmasOrigem: [],
        turmasDestino: []
      };
    }

    case LISTA_SERIES_REMATRICULA_SUCESSO: {
      return {
        ...state,
        loader: false,
        series: action.payload,
        // Limpa dependentes
        turmasOrigem: [],
        turmasDestino: []
      };
    }

    case LISTA_TURMAS_ORIGEM_REMATRICULA_SUCESSO: {
      return {
        ...state,
        loader: false,
        turmasOrigem: action.payload
      };
    }

    case LISTA_ANOS_DESTINO_REMATRICULA_SUCESSO: {
      return {
        ...state,
        loader: false,
        anosDestino: action.payload,
        // Limpa dependentes
        turmasDestino: []
      };
    }

    case LISTA_TURMAS_DESTINO_REMATRICULA_SUCESSO: {
      return {
        ...state,
        loader: false,
        turmasDestino: action.payload
      };
    }

    case SALVA_REMATRICULA_SUCESSO: {
      return {
        ...state,
        loader: false,
        showMessageSuccess: true,
        alertMessage: action.payload,
        edicao: false
      };
    }

    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessageError: true,
        loader: false
      };
    }

    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessageError: false,
        showMessageSuccess: false,
        loader: false
      };
    }

    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true
      };
    }

    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false
      };
    }
    
    case ON_SHOW_SUCCESS_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessageSuccess: true,
        loader: false
      };
    }

    case NOVA_REMATRICULA: {
      return {
        ...state,
        edicao: true
      };
    }

    case CANCELA_EDICAO: {
      return {
        ...state,
        edicao: false
      };
    }

    case VERIFICA_SEQUENCIA_ENTURMACAO_SUCESSO: {
      return {
        ...state,
        loader: false,
        sequenciaEnturmacao: action.payload
      };
    }

    case LISTA_TURMAS_FILTRO_REMATRICULA_SUCESSO: {
      return {
        ...state,
        loader: false,
        turmasFiltro: action.payload
      };
    }

    case LISTA_REMATRICULA_SUCESSO: {
      // Como o endpoint agora retorna ID, usamos ele diretamente
      // Mas mantemos o fallback por segurança, caso algum item venha sem ID
      const lista = (action.payload || []).map((item, index) => ({
        ...item,
        id: item.id || `temp_${index}`
      }));
      return {
        ...state,
        loader: false,
        listGrid: lista
      };
    }

    case DETALHE_REMATRICULA_SUCESSO: {
      return {
        ...state,
        loader: false,
        detalhe: action.payload,
        exibirDetalhe: true
      };
    }

    case FECHAR_DETALHE_REMATRICULA: {
      return {
        ...state,
        exibirDetalhe: false,
        detalhe: null
      };
    }

    case ALTERACAO_COMBO: {
      const { nomeCombo, valor } = action.payload;
      const name = nomeCombo[0];
      return {
        ...state,
        [name]: valor
      };
    }

    case ALTERACAO_CAMPO: {
      const { name, value } = action.payload.target;
      return {
        ...state,
        [name]: value
      };
    }

    default:
      return state;
  }
};
